import React from 'react'
import { gql } from '@apollo/client'
import { initializeApollo } from 'gql/client'
import { PAGINA } from 'utils/queries'
import { useTrans } from 'hooks'
import { getImageUrl } from 'utils/safe'
import { Button } from 'components/atoms/index'
import { ThankYouPage, Page } from 'components/organisms/index'
import { NextWrapper } from 'data-fetching-wrapper'

const ThankYouRecuperaPassword = ({ pagina }) => {
  const t = useTrans()
  return (
    <Page pagina={pagina} hideBreadcrumbs customContent>
      <ThankYouPage
        imageUrl={getImageUrl('/images/msgConfirmed_feat.png')}
        title={pagina.titolo}
        text={pagina.descrizione}
        buttons={[<Button label={t('Torna alla homepage')} variant="primary" href="/" />]}
      />
    </Page>
  )
}

export const getStaticProps = NextWrapper.getStaticProps(async ({ locale }) => {
  const client = initializeApollo(null, null, null, locale)

  const {
    data: { pagina },
  } = await client.query({
    query: gql`
      ${PAGINA.replace('__chiave__', 'recupera-password-thank-you')}
    `,
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina }, // will be passed to the page component as props
    revalidate: 60 * 10, // In seconds
  }
}, '/recupera-password/thank-you/')

export default ThankYouRecuperaPassword
